import { PublishGoodsGroup } from './vo/publish-goods-group.model';
import { KYMW4403OutputModel } from './vo/kymw4403-output.model';

/**
 * 掲載商品グループ選択画面の値を管理するクラス
 *
 * @export KYMW4403Model
 * @class KYMW4403Model
 */
export class KYMW4403Model {
  // 掲載商品グループ一覧
  public list: PublishGoodsGroup[] = [];
  // 選択済み掲載商品グループID
  public selectedList: string[] = [];
  // 受注コード
  public orderCode = '';
  // 媒体区分
  public mediumType = '';
}
